import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth/auth.service';
import {BaseComponent} from '../BaseComponent';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {UserModel} from '../../models/UserModel';
import {Platform} from '@ionic/angular';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent extends BaseComponent implements OnInit {
  showMenu: boolean;
  showMenuMobile: boolean;
  user: UserModel;
  showMasterDataUser: boolean;
  mobile: boolean;
  contentMainClass: any;

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute, private authService: AuthService, platform: Platform) {
    super(route, router);
    this.showMenu = false;
    this.showMenuMobile = false;
    this.mobile = this.checkMobile(platform);
    this.user = JSON.parse(sessionStorage.getItem('user'));
    if (this.user) {
      this.showMasterDataUser = this.user.roleList[0].toLowerCase() === this.ROLE.GESTORE_LC.toLowerCase() ? false : true;
    } else {
      this.router.navigate(['login']);
    }
    this.contentMainClass = document.getElementsByClassName('content-main')[0];
  }
  async ngOnInit() {
    this.showMenu = this.authService.isAuthenticated();
  }

  closeMenu(){
    this.showMenuMobile = false;
    this.contentMainClass.classList.remove('resize-main');
  }

  openMenu(){
    this.showMenuMobile = !this.showMenuMobile;
    if(!this.mobile && this.showMenuMobile) {
      this.contentMainClass.classList.add('resize-main');
    } else {
      this.contentMainClass.classList.remove('resize-main');
    }
  }
  onResize(event) {
    if (event.target.innerWidth <= 1024) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }
}
